var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container", attrs: { id: "position-box" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "success", icon: "el-icon-back", id: "myadd" },
              on: { click: _vm.returnFun }
            },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "warning", id: "myadd" },
              on: { click: _vm.deployFun }
            },
            [_vm._v("生成配置")]
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { disabled: "", type: "text", id: "deviceTypeCode" },
            model: {
              value: _vm.deviceTypeCode,
              callback: function($$v) {
                _vm.deviceTypeCode = $$v
              },
              expression: "deviceTypeCode"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            { attrs: { width: "350px" } },
            [
              _c("DetailTree", {
                ref: "detailTree",
                on: { handleGetContent: _vm.handleGetContent }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-main",
            [
              _c("DetailContent", {
                ref: "detailContent",
                on: { handleRefreshMenu: _vm.handleRefreshMenu }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }